import { SegmentSchema } from '@sondermind/segment';

export enum QuickIntakeSegmentEvents {
  QUICK_LEAD_FORM_STARTED = 'Quick Lead Form - Started',
  QUICK_LEAD_FORM_SUBMITTED = 'Quick Lead Form - Submitted',
  QUICK_LEAD_FORM_CHANGED = 'Quick Lead Form - Field User Input Started'
}

export interface IQuickLeadFormChangedData {
  fieldName: string;
  value?: boolean | string;
}

export interface IQuickIntakeSegmentSchema extends SegmentSchema {
  [QuickIntakeSegmentEvents.QUICK_LEAD_FORM_STARTED]: object;
  [QuickIntakeSegmentEvents.QUICK_LEAD_FORM_SUBMITTED]: object;
  [QuickIntakeSegmentEvents.QUICK_LEAD_FORM_CHANGED]: IQuickLeadFormChangedData;
}
